import { render, staticRenderFns } from "./loyaltyMomentsReminder.vue?vue&type=template&id=27bb3bfa&"
import script from "./loyaltyMomentsReminder.vue?vue&type=script&lang=js&"
export * from "./loyaltyMomentsReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports